export default {
  add: 'Add',
  edit: 'Edit',
  category: 'Category',
  categories: 'Categories',
  description: 'Description',
  amount: 'Amount',
  number: 'Number',
  spentIn: 'Spent in {month}',
  noCategory: 'Without Category',
  update: 'Update',
  googleLogin: 'Login with Google',
  facebookLogin: 'Login with Facebook',
  password: 'Password',
  signUp: 'SignUp',
  logIn: 'Login',
  addNewCategory: 'Add New Category',
  editCategory: 'Edit Category',
  expenses: 'Expenses',
  incomes: 'Incomes',
  investments: 'Investments',
  about: 'This is an about page',
  notFound: 'This page does not exist',
  validations: {
    required: '{field} field must not be empty',
    range: '{field} has to be between {min} and {max}'
  }
}
